// @flow

import StateListenerRegistry from '../../../../react/features/base/redux/StateListenerRegistry';
import debounce from 'lodash/debounce';
import {
    getMonitorIndexForWhiteboard
} from '../../../wizyconf/components/large-video/functions';

import WildixUIEvents from '../../../service/WildixUIEvents';

import VideoLayout from '../../../../modules/UI/videolayout/VideoLayout';


let oldIndex = -1;


/**
 * Updates the on stage participant video.
 */
StateListenerRegistry.register(
    /* selector */ state => state['wizyconf/large-video'].participantIds,
    /* listener */ (participantIds, { getState }) => {
        const state = getState();
        const whiteboardIndex = getMonitorIndexForWhiteboard(state);

        if (oldIndex !== whiteboardIndex) {
            oldIndex = whiteboardIndex;
            document.body.classList.remove('whiteboard_0', 'whiteboard_1', 'whiteboard_2');
            document.body.classList.add(`whiteboard_${whiteboardIndex}`);
        }

        VideoLayout.updateLargeVideo(participantIds, true);
    }
);


/**
 * Handles changes in the visible participants in the filmstrip. The listener is debounced
 * so that the client doesn't end up sending too many bridge messages when the user is
 * scrolling through the thumbnails prompting updates to the selected endpoints.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/filmstrip'].visibleRemoteParticipants,
    /* listener */ debounce(visibleRemoteParticipants => {
        APP.wildix.eventEmitter.emit(WildixUIEvents.VISIBLE_PARTICIPANT_LIST, visibleRemoteParticipants);
    }, 100));

/**
 * Handles changes in the remote participants in the filmstrip.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/filmstrip'].remoteParticipants,
    /* listener */ debounce(remoteParticipants => {
        APP.wildix.eventEmitter.emit(WildixUIEvents.REMOTE_PARTICIPANT, remoteParticipants);
    }, 100));

/**
 * Handles changes in filmstrip visible.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/filmstrip'].visible,
    /* listener */ debounce(visible => {
        APP.wildix.eventEmitter.emit(WildixUIEvents.UPDATE_TOGGLE_BUTTON, visible);
    }, 10));

/**
 * Handles changes in tileView.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/video-layout'].tileViewEnabled,
    /* listener */ debounce(tileViewEnabled => {
        if (!tileViewEnabled) {
            APP.wildix.eventEmitter.emit(WildixUIEvents.UPDATE_TOGGLE_BUTTON);
        }
    }, 10));
